import React, { useEffect, useRef, useState } from "react";

/**
 * ScrollProgress — a thin gold bar pinned to the top of the viewport
 * that fills as the user scrolls through the page.
 * Apple.com style: subtle, no extra height, smooth width transitions.
 */
export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  const rafRef = useRef(0);

  useEffect(() => {
    const update = () => {
      const scrolled = window.scrollY;
      const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      setProgress(Math.min(1, scrolled / max));
    };
    const onScroll = () => {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(update);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <div
      className="scroll-progress"
      style={{ width: `${progress * 100}%` }}
      data-testid="scroll-progress"
      aria-hidden="true"
    />
  );
}
